export const getPushNotificationById = (payload: { id: number }) => ({
    type: "@saga/GET_NOTIFICATION_BY_ID",
    payload,
  });
  